<document-editor
  id="docxForComments"
  documentServerUrl="docServerUrl"
  [config]="onlyOfficeConfig"
  [events_onDocumentReady]="onlyOfficeOnDocumentReady"
  [onLoadComponentError]="onLoadComponentError"
></document-editor>
